// Utility to handle framer-motion imports gracefully
// Falls back to regular HTML elements with CSS 3D transforms if framer-motion is not installed

let motion = null;
let hasFramerMotion = false;

try {
  const framerMotion = require('framer-motion');
  motion = framerMotion.motion;
  hasFramerMotion = true;
} catch (e) {
  // Framer-motion not installed, create fallback with CSS 3D transforms
  const createFallback = (Tag) => ({ 
    children, 
    className = '', 
    style = {}, 
    initial,
    animate,
    variants,
    transition,
    whileHover,
    ...props 
  }) => {
    // Determine which CSS class to add based on variants
    let finalClassName = className;
    let finalStyle = { ...style };
    
    // Add 3D animation classes based on variants
    if (variants) {
      if (variants.hover && variants.hover.rotateY) {
        finalClassName += ' image-3d';
      } else if (variants.hover && (variants.hover.rotateX || variants.hover.rotateY)) {
        finalClassName += ' card-3d';
      }
    }
    
    // Handle initial/animate props for basic animations
    if (initial && typeof initial === 'object') {
      if (initial.opacity !== undefined && !animate) {
        finalStyle.opacity = initial.opacity;
      }
      if (initial.y !== undefined && !animate) {
        finalStyle.transform = `translateY(${initial.y}px)`;
      }
      if (initial.scale !== undefined && !animate) {
        finalStyle.transform = `scale(${initial.scale})`;
      }
    }
    
    if (animate && typeof animate === 'object') {
      if (animate.opacity !== undefined) {
        finalStyle.opacity = animate.opacity;
      }
      if (animate.y !== undefined) {
        finalStyle.transform = `translateY(${animate.y}px)`;
      }
      if (animate.scale !== undefined) {
        finalStyle.transform = `scale(${animate.scale})`;
      }
    }
    
    // Add transition if specified
    if (transition && typeof transition === 'object') {
      const duration = transition.duration || 0.3;
      const delay = transition.delay || 0;
      finalStyle.transition = `all ${duration}s ease-out ${delay}s`;
    }
    
    return (
      <Tag className={finalClassName} style={finalStyle} {...props}>
        {children}
      </Tag>
    );
  };

  motion = {
    section: createFallback('section'),
    div: createFallback('div'),
    img: createFallback('img'),
    h1: createFallback('h1'),
  };
}

export { motion, hasFramerMotion };
export default motion;
